const STORAGE_KEY = "kan.party.saved_roster_v1";
const MAX_SAVED_PLAYERS = 60;

export type PartySavedRosterData = {
  v: 1;
  rememberNames: boolean;
  playerNames: string[];
  teamA: string;
  teamB: string;
};

export const emptyPartySavedRoster = (): PartySavedRosterData => ({
  v: 1,
  rememberNames: false,
  playerNames: [],
  teamA: "",
  teamB: "",
});

/** Move each name to the end (most recently used); dedupe by exact string after trim. */
export function mergePlayerNamesMru(existing: string[], incoming: string[]): string[] {
  let out = existing.map((s) => s.trim()).filter(Boolean);
  for (const raw of incoming) {
    const t = raw.trim();
    if (!t) continue;
    out = out.filter((x) => x !== t);
    out.push(t);
  }
  return out.slice(-MAX_SAVED_PLAYERS);
}

export function readPartySavedRoster(): PartySavedRosterData {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyPartySavedRoster();
    const parsed = JSON.parse(raw) as Partial<PartySavedRosterData>;
    if (!parsed || parsed.v !== 1) return emptyPartySavedRoster();
    return {
      v: 1,
      rememberNames: Boolean(parsed.rememberNames),
      playerNames: Array.isArray(parsed.playerNames)
        ? parsed.playerNames.map((s) => String(s).trim()).filter(Boolean).slice(-MAX_SAVED_PLAYERS)
        : [],
      teamA: typeof parsed.teamA === "string" ? parsed.teamA : "",
      teamB: typeof parsed.teamB === "string" ? parsed.teamB : "",
    };
  } catch {
    return emptyPartySavedRoster();
  }
}

export function writePartySavedRoster(data: PartySavedRosterData): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}
